import sessionApi from './apiClient';
import { userService, securityService } from './adminService';
import type { QaUserPayload } from './adminService';
import { inventoryService } from './inventoryService';
import { issuanceService } from './issuanceService';
import { inspectionService } from './inspectionService';
import { notificationService } from './notificationService';
import { archiveService } from './archiveService';

export { sessionApi };
export { authService } from './authService';
export { dashboardService } from './dashboardService';
export { userService, securityService } from './adminService';
export { inventoryService } from './inventoryService';
export { issuanceService } from './issuanceService';
export { inspectionService } from './inspectionService';
export { notificationService } from './notificationService';
export { archiveService } from './archiveService';
export type { DashboardSummary } from './dashboardService';
export type { FirearmIncidentPayload, FirearmPayload, OfficerPayload } from './inventoryService';
export type { IssuancePayload } from './issuanceService';
export type { DepartmentListParams, DepartmentPayload, QaUserPayload } from './adminService';

export const frsQaService = {
  getUsers: (filters: { is_active?: string; role?: string; search?: string } = {}) =>
    sessionApi.get('/users/', { params: filters }).then((response) =>
      Array.isArray(response.data) ? response.data : response.data?.results || []
    ),
  createUser: (payload: QaUserPayload) => userService.createUser(payload),
  activateUser: (id: number) => sessionApi.post(`/users/${id}/activate/`).then((response) => response.data),
  deactivateUser: (id: number) => sessionApi.post(`/users/${id}/deactivate/`).then((response) => response.data),
  unlockUser: (id: number) => userService.unlockUser(id),
  assignUserRole: (id: number, payload: { role: string; remarks?: string }) =>
    sessionApi.post(`/users/${id}/assign-role/`, payload).then((response) => response.data),

  getOfficers: inventoryService.getOfficers,
  createOfficer: inventoryService.createOfficer,
  updateOfficer: inventoryService.updateOfficer,
  deleteOfficer: inventoryService.deleteOfficer,
  getFirearms: inventoryService.getFirearms,
  createFirearm: inventoryService.createFirearm,
  getReturnRecords: inventoryService.getReturnRecords,
  getFirearmIncidents: inventoryService.getFirearmIncidents,
  createFirearmIncident: inventoryService.createFirearmIncident,
  updateFirearmIncidentStatus: inventoryService.updateFirearmIncidentStatus,
  acknowledgeFirearmIncident: inventoryService.acknowledgeFirearmIncident,

  getIssuances: issuanceService.getIssuances,
  createIssuance: issuanceService.createIssuance,
  returnIssuance: issuanceService.returnIssuance,
  revokeIssuance: issuanceService.revokeIssuance,
  getAres: issuanceService.getAres,

  getReconciliationReports: inspectionService.getReconciliationReports,
  getGeneratedReports: inspectionService.getGeneratedReports,
  generateReconciliationPdf: inspectionService.generateReconciliationPdf,

  getSystemNotifications: notificationService.getSystemNotifications,
  generateLtopfNotifications: notificationService.generateLtopfNotifications,
  markNotificationRead: notificationService.markNotificationRead,
  dismissNotification: notificationService.dismissNotification,

  getAuditLogs: securityService.getAuditLogs,
  verifyAuditChain: securityService.verifyAuditChain,
  getBackupStatus: securityService.getBackupStatus,
  runBackup: securityService.runBackup,
  getBackupRuns: securityService.getBackupRuns,

  getArchiveRecords: archiveService.getArchiveRecords,
  getArchiveBatches: archiveService.getArchiveBatches,
  dryRunArchiveBatch: archiveService.dryRunBatch,
};

export default sessionApi;
